module.exports = __webpack_public_path__ + "media/warranty-claim/warranty_photo_requirements_thumbnail-3b1cd808.png";